import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {getOptionsFromJsonString} from "./utilities/options";

export function initItemlistSlider(query = document.querySelectorAll('.itemboxList.swiper'),options = {}) {
    let defaultOptions = {
        breakpointItems: {
            xs: 2.2,
            sm: 3,
            md: 4,
            lg: 4,
            xlg: 6
        }
    };

    defaultOptions = {...defaultOptions, ...options};

    for (let itemlist of query) {

        let options = getOptionsFromJsonString(itemlist.getAttribute('data-options'), defaultOptions);
        let childrenCount = itemlist.querySelectorAll('.swiper-wrapper > *').length;
        let loop = false;

        options = {
            ...options,
            breakpointItems: {
                ...options.breakpointItems
            }
        };

        if(itemlist.closest(".col-md-8")){
            options.breakpointItems.md = 3;
            options.breakpointItems.lg = 3;
            options.breakpointItems.xlg = 3;
        }

        if (itemlist.closest('.bannerWithItemSlider')) {
            options.breakpointItems.xs = 1;
            options.breakpointItems.sm = 1;
            options.breakpointItems.md = 1;
            options.breakpointItems.lg = 1;
            options.breakpointItems.xlg = 1;
        }

        let breakpoints = {
            xs: {
                items: options.breakpointItems.xs,
            },
            sm: {
                items: options.breakpointItems.sm,
            },
            md: {
                items: options.breakpointItems.md,
            },
            lg: {
                items: options.breakpointItems.lg,
            },
            xlg: {
                items: options.breakpointItems.xlg,
            }
        };

        //deactivate autoplay
        breakpoints.xs.autoplay = false;
        breakpoints.sm.autoplay = false;
        breakpoints.md.autoplay = false;
        breakpoints.lg.autoplay = false;
        breakpoints.xlg.autoplay = false;

        if (window.outerWidth > GLOBALS.gridBreakpoints.sm && childrenCount > breakpoints.sm.items) {
            loop = true;
        }

        if (window.outerWidth > GLOBALS.gridBreakpoints.md && childrenCount > breakpoints.md.items) {
            loop = true;
        }

        if (window.outerWidth > GLOBALS.gridBreakpoints.xlg && childrenCount > breakpoints.xlg.items) {
            loop = true;
        }

        Swiper.use([Autoplay, Navigation, Pagination]);
        new Swiper(itemlist, {
            loop: false,
            speed: 300,
            spaceBetween: 20,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: itemlist.nextElementSibling.querySelector('.swiper-button-next'),
                prevEl: itemlist.nextElementSibling.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xs.items,
                },
                768: {
                    slidesPerView: breakpoints.sm.items,
                },
                1024: {
                    slidesPerView: breakpoints.md.items,
                },
                1250: {
                    slidesPerView: breakpoints.lg.items,
                },
                1540: {
                    slidesPerView: breakpoints.xlg.items,
                    spaceBetween: 40,
                }
            }
        });
    }
}